import styled from 'styled-components';
import { Wrapper } from '../shared/commonStyles';
import FadeInFromBottom from '../shared/FadeInFromBottom';

import CoverModel_2 from '../../assets/image/cover_model/202501_placoledressy_2.jpg';

const TitleWrapper = styled.div`
  text-align: center;
`;

const Title = styled.h1`
  font-size: 11px;
  font-family: Futura;
  font-weight: 500;
  margin-bottom: 6px;
`;

const Text1 = styled.h2`
  display: inline-block;
  font-size: 15px;
  font-weight: bold;
  border-top: 1px solid #000;
  padding: 4px 8px 0;
`;

const Highlight = styled.span`
  font-size: 26px;
  font-family: 'Times New Roman', serif;
  margin-left: 5px;
`;

const Text2 = styled.h3`
  font-size: 11px;
  padding-top: 4px;
`;

const CoverModelWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 16px 0;
`;

const CoverModel = styled.img`
  width: ${(props) => (props.isPc ? '60%' : '80%')};
  height: auto;
  
`;

const Description = styled.p`
  font-size: 11px;
  line-height: 20px;
  text-align: center;
`;

const ShowMoreButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

const ShowMoreButton = styled.a`
  border: 1px solid #000;
  padding: 8px 50px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
`;

const SectionMedia = (props) => {
  return (
    <Wrapper id="media">
      <FadeInFromBottom>
        <TitleWrapper>
          <Title>MEDIA</Title>
          <Text1>SNSフォロワー数 <Highlight>No.1</Highlight></Text1>
          <Text2>DRESSY編集部が今のトレンドを紹介</Text2>
        </TitleWrapper>
        <CoverModelWrapper>
          <CoverModel src={CoverModel_2} alt='PLACOLE&DRESSY' isPc={props.pc}/>
        </CoverModelWrapper>
        <Description>
          DRESSY(ドレシー)はウェディングドレスメディアです<br />
          シーズン毎に開催されるウェディングドレスの展示会情報や<br />
          ファッションやエンタメ情報、結婚式・結婚準備の知識など、<br />
          すべての人が魔法にかかる情報を発信しています
        </Description>
        <ShowMoreButtonWrapper>
          <ShowMoreButton  onClick={() => {
            window.open('https://dressy.pla-cole.wedding/', '_blank');
          }}>
            詳しくみる
          </ShowMoreButton>
        </ShowMoreButtonWrapper>
      </FadeInFromBottom>
    </Wrapper>
  );
  };
  
export default SectionMedia;
  